
import EventForm from './EventForm'

const EditEvent = () => {
  return (
    <div>
        <EventForm />
    </div>
  )
}

export default EditEvent